import { render, staticRenderFns } from "./passportMap.vue?vue&type=template&id=10fb904b&"
import script from "./passportMap.vue?vue&type=script&lang=js&"
export * from "./passportMap.vue?vue&type=script&lang=js&"
import style0 from "./passportMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports